module.exports = __webpack_public_path__ + "static/nat-4-a9fb8c04b51ec6beab2becf60b003e85.jpg";